import React from "react";
import { Tag } from "antd";

export type StatusSolicitacaoReservaFront =
  | "CRIADA"
  | "SR_ENVIADA"
  | "INICIADA"
  | "AGUARDANDO_PAGAMENTO_TAXA"
  | "PAGAMENTO_TX_INTERROMPIDO"
  | "TAXA_PAGA"
  | "AGUARDANDO_ESTORNO"
  | "ESTORNADO"
  | "FINALIZADO_FRACASSO"
  | "NAO_TEM_MAIS_INTERESSE"
  | "SEM_INTERESSE_PERIODO_PROCURADO"
  | "SEM_INTERESSE_PERIODO_ENCONTRADO"
  | "EM_VERIFICACAO"
  | "RESERVA_CONFIRMADA"
  | "RESERVA_FINALIZADA"
  | "RESERVA_CANCELADA";

const STATUS_META: Record<
  StatusSolicitacaoReservaFront,
  { color: string; label: string }
> = {
  CRIADA: { color: "default", label: "Criada" },
  SR_ENVIADA: { color: "blue", label: "SR enviada" },
  INICIADA: { color: "default", label: "Iniciada" },
  AGUARDANDO_PAGAMENTO_TAXA: { color: "gold", label: "Aguardando taxa" },
  PAGAMENTO_TX_INTERROMPIDO: {
    color: "volcano",
    label: "Pagamento de Taxa Interrompido",
  },
  TAXA_PAGA: { color: "cyan", label: "Taxa paga" },
  AGUARDANDO_ESTORNO: { color: "orange", label: "Aguardando estorno" },
  ESTORNADO: { color: "red", label: "Estornado" },
  FINALIZADO_FRACASSO: { color: "volcano", label: "Finalizado fracasso" },
  NAO_TEM_MAIS_INTERESSE: { color: "orange", label: "Nao tem mais interesse" },
  SEM_INTERESSE_PERIODO_PROCURADO: {
    color: "orange",
    label: "Sem interesse no periodo procurado",
  },
  SEM_INTERESSE_PERIODO_ENCONTRADO: {
    color: "orange",
    label: "Sem interesse no periodo encontrado",
  },
  EM_VERIFICACAO: { color: "processing", label: "Em verificacao" },
  RESERVA_CONFIRMADA: { color: "green", label: "Reserva confirmada" },
  RESERVA_FINALIZADA: { color: "success", label: "Reserva finalizada" },
  RESERVA_CANCELADA: { color: "red", label: "Reserva cancelada" },
};

type Props = {
  status?: StatusSolicitacaoReservaFront | null;
};

export default function SolicitacaoReservaStatusTag({ status }: Props) {
  if (!status || !STATUS_META[status]) return null;

  const meta = STATUS_META[status];

  return (
    <Tag color={meta.color} style={{ borderRadius: 999 }}>
      {meta.label}
    </Tag>
  );
}
